import styled from 'styled-components';
import { COLORS } from '../../../game/data/colors';

export const SidebarTab = styled('div')<{ $active?: boolean }>(({ $active: active = false }) => ({
  flex: 1,
  textAlign: 'center',
  fontSize: '0.8rem',
  fontWeight: 500,
  backgroundColor: active ? COLORS.zinc_800 : COLORS.zinc_900,
  padding: 8,
  '& img': {
    width: 35,
  },
  '&:hover': {
    backgroundColor: COLORS.zinc_800,
    cursor: 'pointer',
  },
}));
